module.exports = __webpack_public_path__ + "img/Cuban_Bowl_Chicken.e9dda4b8.jpg";